import dynamic from 'next/dynamic';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import EFEmail from '@/components/UI/svg/WTB/EFEmail';
import { updateBladeCalEmail } from '@/service';

const EmailModal = dynamic(() => import('./EmailSuccessModal'), { ssr: true });
export default function NotRecommended({ id }: any) {
    const { useLang, useRouter, useState, gtm, Link } = useGlobal();
    const { t } = useLang('bladecalculator');
    const { locale } = useRouter();
    const [inputValue, setInputValue] = useState('');
    const [tip, setTip] = useState('');
    const [showModal, setShowModal] = useState(false);
    const onInput = (e: any) => {
        setInputValue(e?.target.value.trim());
    };
    const calDisable = () => {
        const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
        return !reg.test(inputValue);
    };
    const onSubmit = async () => {
        try {
            const res = await updateBladeCalEmail({ email: inputValue, id }, locale);
            if (res?.code === '0') {
                setShowModal(true);
            }
            if (res?.code !== '0') {
                setTip(res?.message);
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'checklist_email_submit',
                product_name: 'EcoFlow BLADE',
                list_name: 'Results_Not Recommended',
                button_name: t('detail.calculator_result_card1_email_btn'),
                status: res?.code === '0' ? 'success' : 'fail',
            });
        } catch (e: any) {
            console.error(e);
        }
    };
    return (
        <div className="not-recommended result-box">
            <Link className="modal-close" href={'/blade-robotic-lawn-mower'}>
                &times;
            </Link>
            <div className="img-box">
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/pc/result_not_recommended.webp')}
                    src={require('@publicLocal/blade/calculator/pc/result_not_recommended.png')}
                    alt={t('detail.calculator_result_card1_title')}
                    aria-lable={t('detail.calculator_result_card1_title')}
                />
            </div>
            <p className="result-title">{t('detail.calculator_result_card1_title')}</p>
            <p className="result-text">{t('detail.calculator_result_card1_text')}</p>
            <div className="input-box">
                <div className="box-inner">
                    <input
                        type="text"
                        className="email"
                        value={inputValue}
                        placeholder={t('detail.calculator_result_card1_email_placeholder')}
                        onInput={onInput}
                    ></input>
                    <span className="email-icon">
                        <EFEmail />
                    </span>
                </div>
                <button className="btn" disabled={calDisable()} onClick={onSubmit}>
                    {t('detail.calculator_result_card1_email_btn')}
                </button>
            </div>
            {tip && <p className="tip">{tip}</p>}
            {showModal && <EmailModal />}
        </div>
    );
}
